module.exports = __webpack_public_path__ + "static/planejamento-curricular-2bebd4cf923b257e85d0c1cfa1f84d2b.jpg";